module.exports = __webpack_public_path__ + "img/kotkip_succes.aaf69e26.png";